import { envConfig } from '~/utils/env';
import { BaseRestRepository } from './baseRestRepository';
import type { TransactionDto } from '~/swagger/accounting/Api';

const TRANSACTIONS_URL = `${envConfig.service.accounting}/company-portal/transactions`;

export type CompanyPortalTransactionDto = TransactionDto;

export class CompanyPortalTransactionRepository extends BaseRestRepository {
  public async getTransaction(transactionId: string): Promise<CompanyPortalTransactionDto> {
    const response = await this.fetchWithAuth(`${TRANSACTIONS_URL}/${transactionId}`);
    return this.getJsonResponse(response);
  }
}
